import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPersonTab = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		id: "Vector",
		d: "M16.125 6.75C15.9413 9.22828 14.0625 11.25 12 11.25C9.9375 11.25 8.05547 9.22875 7.875 6.75C7.6875 4.17188 9.51562 2.25 12 2.25C14.4844 2.25 16.3125 4.21875 16.125 6.75Z",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		id: "Vector_2",
		d: "M12 14.25C7.92187 14.25 3.78281 16.5 3.01687 20.7469C2.92453 21.2588 3.21422 21.75 3.75 21.75H20.25C20.7862 21.75 21.0759 21.2588 20.9836 20.7469C20.2172 16.5 16.0781 14.25 12 14.25Z",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeMiterlimit: 10
	})]
});
export default SvgPersonTab;
